import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as actions from '../../../../../store/actions';

class River extends Component {
  render(){
    const id = `hover-map-${this.props.index}`;
    return (<div id={id} style={{width: '100%', height: '100%'}} onMouseEnter={(e) => this.props.findMap(this.props.text, id)}>{this.props.text}</div>)
  }
}

const mapDispatchToProps = dispatch => {
  return {
    findMap: (river) => dispatch(actions.findMap(river))
  }
}

export default connect(null, mapDispatchToProps)(River);



// WEBPACK FOOTER //
// ./src/components/panel/items/filters/filterComponents/River.js